import { useStore } from "../lib/store";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export const Contact = () => {
  const { business } = useStore();

  return (
    <section id="contacto" className="section-padding bg-white" data-testid="contact-section">
      <div className="container-aura">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-xs tracking-luxe uppercase text-gold mb-4">Contacto</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink leading-tight mb-5">
            Encuéntranos
          </h2>
          <div className="gold-divider mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-ink-soft font-light">
            Estamos aquí para responder tus dudas y darte la bienvenida a AURA.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 items-stretch">
          {/* Info cards */}
          <div className="lg:col-span-5 grid gap-5">
            <InfoRow
              icon={<MapPin size={20} />}
              title="Dirección"
              testid="contact-address"
              value={business.address}
            />
            <InfoRow
              icon={<Phone size={20} />}
              title="Teléfono / WhatsApp"
              testid="contact-phone"
              value={business.whatsapp}
            />
            <InfoRow
              icon={<Mail size={20} />}
              title="Correo electrónico"
              testid="contact-email"
              value={business.email}
            />
            <div className="p-6 md:p-7 rounded-3xl bg-beige-50 border border-beige-200">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-gold">
                  <Clock size={20} />
                </div>
                <div className="font-serif text-lg text-ink">Horarios</div>
              </div>
              <div className="space-y-2" data-testid="contact-hours">
                {business.hours?.map((h, i) => (
                  <div key={i} className="flex items-center justify-between text-sm">
                    <span className="text-ink-soft">{h.day}</span>
                    <span className="text-ink font-medium">{h.time}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="lg:col-span-7 rounded-3xl overflow-hidden border border-beige-200 min-h-[450px] bg-beige-50" data-testid="contact-map">
            <iframe
              src={business.mapsEmbed}
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: 450 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación AURA"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

const InfoRow = ({ icon, title, value, testid }) => (
  <div className="p-6 md:p-7 rounded-3xl bg-beige-50 border border-beige-200 flex gap-4 items-start" data-testid={testid}>
    <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-gold flex-shrink-0">
      {icon}
    </div>
    <div>
      <div className="text-xs tracking-luxe uppercase text-ink-soft mb-1">{title}</div>
      <div className="font-serif text-lg text-ink leading-tight">{value}</div>
    </div>
  </div>
);
